import { combineReducers } from 'redux'

import rolesReducer from './roles-reducer'
import userReducer from './user-reducer'
import usersReducer from './users-reducer'

export default combineReducers({
  roles: rolesReducer,
  users: usersReducer,
  user: userReducer,
})
